import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Components
import MenuPanel from './menupanel';
import ModalLogin from '../Modals/modalLogin';

// Images
import Logo from '../../img/logo-expo-medica.png';
import Carrito from '../../img/cart.png';

class Header extends Component {
   constructor(props) {
      super(props);
      this.state = {
         carrito_length: this.props.carrito.length,
         login_modal: false,
         registro_modal: false,
      };
   }

   componentDidUpdate(nextProps) {
      if (this.props.carrito !== nextProps.carrito) {
         this.setState({ carrito_length: nextProps.carrito });
      }
   }

   logIn() {
      // Trigger Login Modal
      document.getElementById('modal-login').classList.remove('hidden');
   }

   logOut() {
      this.props.dispatch({ type: 'LOGOUT' });
      document.getElementById('close-modal-login').click();
      window.location = '/inicio';
   }

   componentDidMount() {
      document
         .getElementById('close-modal-login')
         .addEventListener('click', function () {
            document.getElementById('modal-login').classList.add('hidden');
         });
      // Mobile Menu
      document.getElementById('open-menu').onclick = function () {
         document.getElementById('menu-panel').style.left = '0%';
      };

      document.getElementById('close-menu').onclick = function () {
         document.getElementById('menu-panel').style.left = '100%';
      };
   }

   render() {
      let numberCart = 0;
      if (window.localStorage.getItem('EXPMED')) {
         numberCart = JSON.parse(window.localStorage.getItem('EXPMED'));
         numberCart = numberCart.carrito_count;
      }
      return (
         <header className="flex">
            <div className="column">
               <div
                  className={`${
                     this.props.inicio ? 'header-gral' : 'home-header'
                  }`}
               >
                  <div className="justify-center">
                     <div className="container">
                        <div className="row">
                           <button className="btn-clean" id="open-menu">
                              <i className="fas fa-bars color-red"></i>
                           </button>
                           <div className="logo align-start">
                              <Link to="/inicio">
                                 <div className="responsive-img">
                                    <img
                                       src={Logo}
                                       alt="Logo Expo Médica"
                                       title="Logo Expo Médica"
                                    />
                                 </div>
                              </Link>
                           </div>
                           <div className="header-links row align-center">
                              {/*<div
                                 id="open-modal-login"
                                 className="header-login"
                                 onClick={this.logIn.bind(this)}
                              >
                                 <img src={User} />
               </div>*/}
                              <div className="header-cart">
                                 <Link to="/carrito" className="color-white">
                                    <img src={Carrito} alt="cart" />
                                    <div className="numbercart">
                                       {numberCart}
                                    </div>
                                 </Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <MenuPanel></MenuPanel>
               <ModalLogin></ModalLogin>
            </div>
         </header>
      );
   }
}

function mapStateToProps(state) {
   return {
      auth: state.auth,
      user: state.user,
      carrito: state.carrito,
      carrito_count: state.carrito_count,
      busqueda_loading: state.busqueda_loading,
      subtotal: state.subtotal,
   };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/header.js